module.exports = __webpack_public_path__ + "static/media/siddharth_nandy.d44e27b8.png";